import { Observable } from 'rxjs';

export interface SidebarMenuItem {
  label: string | Observable<string>;
  routerLink: string;
  icon: string;
  hidden?: boolean;
  key?: string;
}
